export default {"src":"/pro/_next/static/media/orderbook-asks-icon.6a65ad93.svg","height":21,"width":24,"blurWidth":0,"blurHeight":0};